import __request__ from "routing/request";
export function clear(importId, sourceId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}/import-backends/use/${importId}/clear`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function importAssets(sourceId, importId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}/import-backends/use/${importId}/import`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testNew(sourceId, importId, JSONbody, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}/import-backends/use/${importId}/test`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testExisting(sourceId, importId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}/import-backends/use/${importId}/test`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
